
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.25103 12.0014C6.7198 12.0014 4.66712 9.03192 4.66712 6.50069V5.58391C4.66712 3.05267 6.7198 1 9.25103 1C11.7823 1 13.8349 3.05267 13.8349 5.58391V6.50069C13.8349 9.03192 11.7823 12.0014 9.25103 12.0014Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M12.0014 21.1664C12.0014 20.433 12.2874 19.7436 12.8054 19.2229L16.5624 15.4668C16.2983 15.2349 15.993 15.046 15.6447 14.9287C14.1366 14.4198 11.84 13.8349 9.25103 13.8349C6.66204 13.8349 4.3655 14.4198 2.8574 14.9287C1.74259 15.3055 1 16.3552 1 17.5314V21.1692H12.0014V21.1664Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M14.1036 20.5183L19.4117 15.2101C20.0232 14.5986 21.0133 14.5986 21.6248 15.2101C22.2363 15.8216 22.2363 16.8117 21.6248 17.4232L16.3167 22.7314C16.1443 22.9037 15.9114 23 15.6685 23H13.8349V21.1664C13.8349 20.9235 13.9312 20.6906 14.1036 20.5183Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiInitiateFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
